// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"Footer_footerBox__1e3W-","player":"Footer_player__3SNaM","content":"Footer_content__1uLpA","title":"Footer_title__3384x","body":"Footer_body__2BUsO"};